import {
    DefaultButton,
    Dialog, DialogFooter,
    DialogType, Dropdown, IDropdownOption, Stack
} from "@fluentui/react";

import React from "react";
import CompactColorPicker from "../Inputs/CompactColorPicker";
import NumberField from "../Inputs/NumberField";
import {IStorefrontSectionEditorModalProps} from "./StorefrontSectionStyleEditorModal";
import FontPicker from "../Inputs/FontPicker";

const StorefrontSectionFontEditorModal: React.FC<IStorefrontSectionEditorModalProps> = props => {
    
    const fontStyleOptions: IDropdownOption[] = [
        {
            key: "normal",
            text: "Normal",
        },
        {
            key: "italic",
            text: "Italic"
        },
        {
            key: "oblique",
            text: "Oblique"
        }
    ]

    const fontWeightOptions: IDropdownOption[] = [
        {
            key: 'unset',
            text: 'Unset',
        },
        {
            key: "normal",
            text: "Normal",
        },
        {
            key: "lighter",
            text: "Lighter",
        },
        {
            key: "bold",
            text: "Bold"
        },
        {
            key: "bolder",
            text: "Bolder"
        }
    ]
    
    return (
        <Dialog
            hidden={!props.displayModal}
            onDismiss={props.closer}
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: 'Modify Font',
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            {props.css && 
            <Stack>
                <div style={{fontSize: props.css.fontSize, fontFamily: props.css.fontFamily, fontStyle: props.css.fontStyle, color: props.css.color, fontWeight: props.css.fontWeight, height: '100px'}}>Sample</div>
                <NumberField label="Font Size" value={props.css.fontSize || 16} onChange={val => props.onChange?.('fontSize', val)} />
                <Dropdown label="Font Weight" options={fontWeightOptions} selectedKey={props.css.fontWeight || "normal"} onChange={(e,v) => props.onChange?.('fontWeight', v?.key)} />
                <Dropdown label="Font Style" options={fontStyleOptions} selectedKey={props.css.fontStyle || "normal"} onChange={(e,v) => props.onChange?.('fontStyle', v?.key)} />
                <FontPicker label='Font Family' selectedFont={props.css.fontFamily} onChange={(v) => props.onChange?.('fontFamily', v)} />
                <CompactColorPicker label="Font Color" color={props.css.color ?? '#FFF'} onChange={val => props.onChange?.('color', val)} />
            </Stack>
            }
            <DialogFooter>
                <DefaultButton
                    primary={true}
                    text='Ok'
                    onClick={props.closer}
                />
            </DialogFooter>
        </Dialog>
    );
}
export default StorefrontSectionFontEditorModal;